import type { HtmlTransform } from '../formatMessage'

/**
 * Build an inline SVG string from Lucide-style element descriptors.
 * Size is 1em so it scales with surrounding text. Uses currentColor
 * for stroke, overridden by the colorClass.
 */
function icon(elements: string, colorClass: string, label: string): string {
  return (
    `<svg class="marcus-icon ${colorClass}" aria-label="${label}" role="img"` +
    ` xmlns="http://www.w3.org/2000/svg" width="1em" height="1em"` +
    ` viewBox="0 0 24 24" fill="none" stroke="currentColor"` +
    ` stroke-width="2" stroke-linecap="round" stroke-linejoin="round"` +
    `>${elements}</svg>`
  )
}

// SVG inner elements extracted from lucide-vue-next v0.563.0 icon source
const EMOJI_MAP: [RegExp, string][] = [
  [/✅/g, icon(
    '<circle cx="12" cy="12" r="10"/><path d="m9 12 2 2 4-4"/>',
    'text-success', 'check',
  )],
  [/⚠️/g, icon(
    '<path d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3"/><path d="M12 9v4"/><path d="M12 17h.01"/>',
    'text-warning-ink', 'warning',
  )],
  [/📋/g, icon(
    '<rect width="8" height="4" x="8" y="2" rx="1" ry="1"/><path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"/><path d="M12 11h4"/><path d="M12 16h4"/><path d="M8 11h.01"/><path d="M8 16h.01"/>',
    'text-info', 'clipboard',
  )],
  [/💡/g, icon(
    '<path d="M15 14c.2-1 .7-1.7 1.5-2.5 1-.9 1.5-2.2 1.5-3.5A6 6 0 0 0 6 8c0 1 .2 2.2 1.5 3.5.7.7 1.3 1.5 1.5 2.5"/><path d="M9 18h6"/><path d="M10 22h4"/>',
    'text-warning-ink', 'idea',
  )],
  [/❌/g, icon(
    '<circle cx="12" cy="12" r="10"/><path d="m15 9-6 6"/><path d="m9 9 6 6"/>',
    'text-destructive', 'error',
  )],
  [/⚖️/g, icon(
    '<path d="M12 3v18"/><path d="m19 8 3 8a5 5 0 0 1-6 0z"/><path d="M3 7h1a17 17 0 0 0 8-2 17 17 0 0 0 8 2h1"/><path d="m5 8 3 8a5 5 0 0 1-6 0z"/><path d="M7 21h10"/>',
    'text-primary', 'legal',
  )],
]

/**
 * Post-markdown transform: replace common emoji with inline SVG icons.
 *
 * Operates on HTML string — emoji are literal Unicode in text nodes.
 * Streaming-safe: emoji replaced as they appear on each render cycle.
 */
export const emojiIcons: HtmlTransform = (html) => {
  let result = html
  for (const [pattern, replacement] of EMOJI_MAP) {
    result = result.replace(pattern, replacement)
  }
  return result
}
